import React, {Component} from 'react';
import Layout from '../../components/Layout';
import SEO from '../../components/seo';
import { Link, withPrefix } from 'gatsby';

function ManualBlock(props) {
  const {data, manualLink} = props;
  return data && data.manual.text.length > 0 ? <Link className='link' to={manualLink}>Монтаж и эксплуатация</Link> : null;
}

function ExtendedBlock(props) {
  const {data, manualLink} = props;
  if (data && (data.models.items.length > 0 || data.manual.text.length > 0)) {
    if (data.models.items.length > 0) {
      return <div className="row">
        <div className="col-12">
          <h3 className='inline'>Технические характеристики</h3><span className='link m20'><ManualBlock data={data} manualLink={manualLink} /></span>
          <div dangerouslySetInnerHTML={{ __html: data.models.items }}/>
        </div>
      </div>
    } else {
      return <div className="row">
        <div className="col-12">
          <span className='link m20'><ManualBlock data={data} manualLink={manualLink} /></span>
        </div>
      </div>
    }
  } else {
    return null;
  }
}

export default class YataganItem extends Component {
  render() {
    const {catLink, data: {data, title, title_short}, imgs, link} = this.props.pageContext;
    const pageTitle = `Ятаган, воздухоочистное оборудование: ${title}`;
    const manualLink = `${link}/manual`;
    return <Layout>
        <SEO title={pageTitle} />
        <div id="main" className='catalog'>
          <div className="inner">
            <div className='parent-category'>
              <Link to={catLink}>&larr; Воздухоочистное оборудование Ятаган</Link>
            </div>
            <h1>{title}</h1>
            <section className='categories'>
              <div className="row">
                <div className="col-md-4 col-sm-12">
                  {imgs.main && imgs.main.map((item, i) => {
                    return <div className="image fit" key={item + i}>
                      <img src={withPrefix(item)} alt={title_short} />
                    </div>
                  })}
                </div>
                <div className="col-8">
                  {data && data.description && data.description.map((item, i) => {
                      return <p key={i} dangerouslySetInnerHTML={{ __html: item }}/>;
                    })
                  }
                </div>
              </div>
              {data && data.destination && data.destination.length > 0 && <div className="row">
                  <div className="col-12">
                    <h3>Назначение</h3>
                    {data.destination.map((item, i) => {
                      return <p key={i} dangerouslySetInnerHTML={{ __html: item }}/>;
                    })}
                  </div>
                </div>
              }
              <ExtendedBlock data={data} manualLink={manualLink}/>
            </section>
          </div>
        </div>
      </Layout>;
  }
}
